/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ItemsService } from '../services/items.service';
import { ItemBasicInfo, ItemsResponse } from '../model/itemsresponse';
import { ItemsFilterInfo } from '../model/itemsfilterinfo';
import { BannerComponent } from '../../../view/banner/banner.component';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
declare var $: any;

@Component({
    selector: 'zsd-itemlist',
    templateUrl: '../view/itemslist.component.html',
    styleUrls: ['../view/itemslist.component.scss']
})

export class ItemsListComponent implements OnInit {
  itemResultsCount = 0;
  itemsPerPage = 20;
  page = 0;
  sortBy = 'itemName';
  sortOrder = 'DESC';
  isLoading = false;
  maxNoOfItems;
  isItemslist;
  scrollEndReached = false;
  isDesc = false;
  column;

  itemsBasicInfoResponse = new Array<ItemBasicInfo>();
  itemsListResponse: ItemsResponse = new ItemsResponse();
  itemsfilterInfo: ItemsFilterInfo = new ItemsFilterInfo();
  spinnerStart = true; // adding for showing spinner while loading instead of No request message


  @Output() openfilter = new EventEmitter<boolean>();

  itemDataFound = true;
  noRecords;

  constructor(public itemsService: ItemsService,
    private route: ActivatedRoute, public zsdTranslate: ZSDTranslateService, public http: HttpClient,
    public spinnerService: SpinnerService) {
  }


  ngOnInit() {
    /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
   this.sort('itemName');

  }


  sort(property) {
    this.initializeItemsParameters();
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    if (this.isDesc === true) {
      this.sortOrder = 'ASC';
    } else {
      this.sortOrder = 'DESC';
    }
    this.sortBy = property;

    this.initFilter();
    this.applyFilterParamaeter(this.itemsfilterInfo);
    this.isLoading = true;
    this.spinnerService.show();
  }


  applyFilterParamaeter(itemsfilterInfo: ItemsFilterInfo) {
    if (itemsfilterInfo) {
      this.getItemsList(-1, this.sortBy, this.sortOrder, itemsfilterInfo);
    } else {
        itemsfilterInfo.searchTerm = '';
        itemsfilterInfo.categoryIds = [];
        itemsfilterInfo.itemTypeIds = [];

      this.getItemsList(this.page, this.sortBy, this.sortOrder, itemsfilterInfo);
    }
  }


  initFilter() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();

    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.itemsfilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
      }
    });
    this.itemsfilterInfo.categoryIds = categoryIds;
    this.itemsfilterInfo.itemTypeIds = itemTypeIds;
  }



  getItemsList(pageNo: number, sortBy: string, sortOrder: string, itemsfilterInfo: ItemsFilterInfo) {
    let params = new HttpParams()
      .set('offset', this.page.toString())
      .set('limit', this.itemsPerPage.toString())
      .set('sortBy', this.sortBy)
      .set('sortOrder', this.sortOrder);

    if (itemsfilterInfo.itemTypeIds) {
      for (let i = 0; i < itemsfilterInfo.itemTypeIds.length; i++) {
        params = params.append('itemTypeId', itemsfilterInfo.itemTypeIds[i].toString());
      }
    }

    if (itemsfilterInfo.categoryIds) {
      for (let i = 0; i < itemsfilterInfo.categoryIds.length; i++) {
        params = params.append('itemCategoryId', itemsfilterInfo.categoryIds[i].toString());
      }
    }

    if (itemsfilterInfo.searchTerm !== null && itemsfilterInfo.searchTerm) {
      params = params.append('searchTerm', itemsfilterInfo.searchTerm);
    }

    if (!this.isLoading) {
      this.isLoading = true;
      this.spinnerService.show();
      if (pageNo === -1) {
        this.isLoading = true;
        this.spinnerService.show();
        this.page = 0;
        this.sortBy = sortBy;
        this.sortOrder = sortOrder;
        this.initializeItemsParameters();
        pageNo = 0;
      }
      this.itemsService
        .getItemsList(params)
        .subscribe(
          (itemsResponse: ItemsResponse) => {
            this.maxNoOfItems = itemsResponse.resultCount;
            if (this.maxNoOfItems > 0) {
              this.isItemslist = true;
              this.scrollEndReached = false;
            }
            this.itemsBasicInfoResponse = this.itemsBasicInfoResponse.concat(
                itemsResponse.results
            );
            this.page++;
            if (this.itemsBasicInfoResponse.length >= this.maxNoOfItems) {
              // reached end of list
              this.scrollEndReached = true;
            }
            this.isLoading = false;
            this.spinnerStart = false;
          },
          err => {
            console.error(err.error);
            this.isLoading = false;
            this.spinnerStart = false;
          }
        );
    }
  }
  scrollEnd() {
    if (!this.scrollEndReached) {
      this.initFilter();
      this.getItemsList(this.page, this.sortBy, this.sortOrder, this.itemsfilterInfo);
    }
  }
  scrollCur() {
  }

  trackByItems(index) {
    return index;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler() {
    new ItemsListComponent(
        this.itemsService,
        this.route,  this.zsdTranslate,  this.http,
        this.spinnerService );
    window.scrollTo(0, 0);
  }
  initializeItemsParameters() {
    this.isLoading = false;
    this.page = 0;
    this.isItemslist = false;
    this.itemsBasicInfoResponse = [];
    this.itemsfilterInfo = new ItemsFilterInfo();
    this.itemsListResponse = new ItemsResponse();
  }

openFilter() {
  this.openfilter.emit(true);
}

}
